import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { Grid, Dialog, Button, SubmitButton, DatePicker, Chip, htmlParser, SearchSelect, ReactEditor, EditorState, draftToHtml, convertToRaw, ContentState, htmlToDraft, DialogImport } from "../../../../../../";
import { makeStyles } from "@material-ui/styles";
import { TextField } from "formik-material-ui";
import { Debug } from "../../../../../../Molecules/Forms/Debug";
import { Typography, Divider } from "@material-ui/core";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      flexWrap: "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      marginRight: "30px"
    },
    mt16: {
      marginTop: "16px"
    },
    w100: {
      width: "100%"
    },
    actions: {
      display: "flex",
      "justify-content": "flex-end"
    },
    flex: {
      display: "flex"
    },
    chip: {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px"
    },
    vh50: {
      height: "50vh !important"
    },
    editor: {
      background: "#303036",
      borderRadius: "10px",
      overflowY: "auto",
      margin: "16px 0",
      padding: "8px"
    },
    repeatContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-evenly"
    },
    titleRepeatContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-evenly",
      alignItems: "center"
    },
    inputContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    actionsFieldArray: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    containerRepeatsEditor: {
      height: "60vh",
      maxHeight: "60vh",
      overflowY: "scroll"
    },
    divider: {
      margin: "4px 0"
    },
    editor40vh: {
      height: "40vh",
      maxHeight: "40vh",
      overflow: "auto"
    }
  };
});

var DialogCampusGroupSingleActivity = function DialogCampusGroupSingleActivity(props) {
  var _useState = useState(props.variant || "view"),
      _useState2 = _slicedToArray(_useState, 2),
      variant = _useState2[0],
      setVariant = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogImportActivities = _useState4[0],
      setOpenDialogImportActivities = _useState4[1];

  useEffect(function () {
    setVariant(props.variant);
  }, [props.variant]);
  var classes = useStyles();

  var handleModalDialogImportActivities = function handleModalDialogImportActivities() {
    setOpenDialogImportActivities(!openDialogImportActivities);
  };

  var _handleEditorChange = function handleEditorChange(_ref, editorState, aux) {
    var field = _ref.field,
        form = _ref.form;
    form.setFieldValue(field.name, editorState);
  };

  var _importData = function importData(data, setFieldValue, valueActivities) {
    var auxActivities = valueActivities;
    data.forEach(function (dataObject) {
      auxActivities.push(dataObject);
    });
    setFieldValue("repeats", auxActivities);
  };

  var setContent = function setContent() {
    var content;

    switch (variant) {
      case "add":
      case "edit":
        var activitySchema = Yup.object().shape({
          name: Yup.string().required(),
          repeats: Yup.array().of(Yup.object().shape({
            start: Yup.string().required(),
            end: Yup.string().required(),
            venue: Yup.string().required()
          }))
        });
        var initialValues = variant === "add" ? {
          name: "",
          description: "",
          staffDetails: "",
          repeats: [{
            start: null,
            end: null,
            venue: ""
          }]
        } : variant === "edit" ? props.data ? _objectSpread(_objectSpread({}, props.data), {}, {
          description: EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(props.data.description).contentBlocks, htmlToDraft(props.data.description).entityMap)),
          staffDetails: EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(props.data.staffDetails).contentBlocks, htmlToDraft(props.data.staffDetails).entityMap))
        }) || {
          name: "",
          description: "",
          staffDetails: "",
          repeats: []
        } : {
          name: "",
          description: "",
          staffDetails: "",
          repeats: []
        } : {};
        content = /*#__PURE__*/React.createElement(Formik, {
          initialValues: initialValues,
          validationSchema: activitySchema,
          onSubmit: function onSubmit(values) {
            if (variant === "add") {
              props.onSubmitAdd(_objectSpread(_objectSpread({}, values), {}, {
                description: values.description ? draftToHtml(convertToRaw(values.description.getCurrentContent())) : "<p></p>",
                staffDetails: values.staffDetails ? draftToHtml(convertToRaw(values.staffDetails.getCurrentContent())) : "<p></p>"
              }));
              props.onClose();
            } else if (variant === "edit") {
              props.onSubmitEdit(_objectSpread(_objectSpread({}, values), {}, {
                description: values.description ? draftToHtml(convertToRaw(values.description.getCurrentContent())) : "<p></p>",
                staffDetails: values.staffDetails ? draftToHtml(convertToRaw(values.staffDetails.getCurrentContent())) : "<p></p>"
              }));
              props.onClose();
            }
          },
          render: function render(_ref2) {
            var isValid = _ref2.isValid,
                isSubmitting = _ref2.isSubmitting,
                values = _ref2.values,
                setFieldValue = _ref2.setFieldValue;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              md: 6
            }, /*#__PURE__*/React.createElement(Grid, {
              container: true
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
              name: "name",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              style: {
                display: "flex",
                justifyContent: "flex-end"
              }
            }, /*#__PURE__*/React.createElement(Button, {
              variant: "outlined",
              onClick: handleModalDialogImportActivities
            }, props.translation ? props.translation.buttons ? props.translation.buttons.import_activities || "Import timetable" : "Import timetable" : "Import timetable"), /*#__PURE__*/React.createElement(DialogImport, {
              open: openDialogImportActivities,
              onClose: handleModalDialogImportActivities,
              title_instructions: props.translation ? props.translation.dialogs ? props.translation.dialogs.import_activities ? props.translation.dialogs.import_activities.title_instructions || null : null : null : null,
              text_instructions: props.translation ? props.translation.dialogs ? props.translation.dialogs.import_activities ? props.translation.dialogs.import_activities.text_instructions || null : null : null : null,
              instructions: props.translation ? props.translation.dialogs ? props.translation.dialogs.import_activities ? props.translation.dialogs.import_activities.instructions || null : null : null : null,
              columnsImport: props.translation ? props.translation.datatables ? props.translation.datatables.import_activities || null : null : null,
              titleSheet: "Actividades",
              options: {
                selectableRows: false
              },
              importData: function importData(data) {
                return _importData(data, setFieldValue, values.repeats);
              },
              translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.import_activities || null : null : null //checked
              ,
              link: "https://plantillas-excell.s3-eu-west-1.amazonaws.com/Manager/07072020_plantilla_actividades.xlsx"
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "body1"
            }, props.translation ? props.translation.texts ? props.translation.texts.date_repeats || "Acitivity's dates" : "Acitivity's dates" : "Acitivity's dates")), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.containerRepeatsEditor
            }, /*#__PURE__*/React.createElement(FieldArray, {
              name: "repeats",
              render: function render(_ref3) {
                var insert = _ref3.insert,
                    remove = _ref3.remove,
                    push = _ref3.push;
                return values.repeats.length > 0 ? values.repeats.map(function (field, index, arr) {
                  return /*#__PURE__*/React.createElement(Grid, {
                    container: true,
                    spacing: 2
                  }, /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    md: 6,
                    lg: 3,
                    className: classes.inputContainer
                  }, /*#__PURE__*/React.createElement(Field, {
                    name: "repeats[".concat(index, "].start"),
                    key: "repeats[".concat(index, "].start"),
                    label: props.translation ? props.translation.inputs ? props.translation.inputs.date_start || "Date start" : "Date start" : "Date start",
                    component: DatePicker,
                    time: true,
                    format: "DD/MM/YYYY HH:mm",
                    margin: "normal",
                    fullWidth: true,
                    variant: "outlined"
                  })), /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    md: 6,
                    lg: 3,
                    className: classes.inputContainer
                  }, /*#__PURE__*/React.createElement(Field, {
                    name: "repeats[".concat(index, "].end"),
                    key: "repeats[".concat(index, "].end"),
                    label: props.translation ? props.translation.inputs ? props.translation.inputs.date_end || "Date end" : "Date end" : "Date end",
                    component: DatePicker,
                    time: true,
                    format: "DD/MM/YYYY HH:mm",
                    margin: "normal",
                    fullWidth: true,
                    variant: "outlined"
                  })), /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    md: 8,
                    lg: 3,
                    className: classes.inputContainer
                  }, /*#__PURE__*/React.createElement(Grid, {
                    container: true,
                    alignItems: "center"
                  }, /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    xs: 12
                  }, /*#__PURE__*/React.createElement(Field, {
                    name: "repeats[".concat(index, "].venue"),
                    key: "repeats[".concat(index, "].venue"),
                    component: SearchSelect,
                    placeholder: props.translation ? props.translation.selects ? props.translation.selects.venue || "Venue" : "Venue" : "Venue",
                    options: props.venues ? props.venues.map(function (venue) {
                      return {
                        label: venue.name,
                        value: venue._id
                      };
                    }) : [],
                    fullWidth: true,
                    marginTopDisabled: true,
                    variant: "outlined"
                  })))), /*#__PURE__*/React.createElement(Grid, {
                    item: true,
                    md: 4,
                    lg: 3,
                    className: classes.actionsFieldArray
                  }, /*#__PURE__*/React.createElement(Button, {
                    key: "delete",
                    disabled: index === 0,
                    type: "button",
                    size: "small",
                    color: "secondary",
                    variant: "outlined",
                    onClick: function onClick() {
                      return remove(index);
                    }
                  }, "-"), arr.length - 1 === index && /*#__PURE__*/React.createElement(Button, {
                    key: "add",
                    type: "button",
                    size: "small",
                    color: "primary",
                    variant: "outlined",
                    onClick: function onClick() {
                      return push({
                        start: null,
                        end: null,
                        venue: null
                      });
                    }
                  }, "+")));
                }) : /*#__PURE__*/React.createElement(Button, {
                  key: "add",
                  type: "button",
                  className: classes.mr30,
                  size: "small",
                  color: "primary",
                  variant: "outlined",
                  onClick: function onClick() {
                    return push({
                      start: null,
                      end: null,
                      venue: null
                    });
                  }
                }, "+");
              }
            })))), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              md: 6
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "body1"
            }, props.translation ? props.translation.texts ? props.translation.texts.details_family || "Family's description" : "Family's description" : "Family's description"), /*#__PURE__*/React.createElement(Typography, {
              variant: "body2"
            }, props.translation ? props.translation.texts ? props.translation.texts.details_family_text || "This information will be visible for parents" : "This information will be visible for parents" : "This information will be visible for parents"), /*#__PURE__*/React.createElement(Field, {
              name: "description"
            }, function (props) {
              // console.log("BasicInfoForm field", props);
              return /*#__PURE__*/React.createElement(ReactEditor, {
                classEditor: "editor22vh",
                name: props.field.name,
                editorState: props.field.value ? props.field.value : EditorState.createEmpty(),
                handleEditorChange: function handleEditorChange(editorSate, aux) {
                  return _handleEditorChange(props, editorSate, aux);
                }
              });
            }), /*#__PURE__*/React.createElement(Typography, {
              variant: "body1"
            }, props.translation ? props.translation.texts ? props.translation.texts.details_staff || "Staff's description" : "Staff's description" : "Staff's description"), /*#__PURE__*/React.createElement(Typography, {
              variant: "body2"
            }, props.translation ? props.translation.texts ? props.translation.texts.details_staff_text || "This information will be visible for staff" : "This information will be visible for staff" : "This information will be visible for staff"), /*#__PURE__*/React.createElement(Field, {
              name: "staffDetails"
            }, function (props) {
              // console.log("BasicInfoForm field", props);
              return /*#__PURE__*/React.createElement(ReactEditor, {
                classEditor: "editor22vh",
                name: props.field.name,
                editorState: props.field.value ? props.field.value : EditorState.createEmpty(),
                handleEditorChange: function handleEditorChange(editorSate, aux) {
                  return _handleEditorChange(props, editorSate, aux);
                }
              });
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true,
              className: classes.actions
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: props.onClose
            }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Save" : "Save" : "Save")));
          }
        });
        break;

      case "view":
        content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          container: true,
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          md: 6
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h4"
        }, props.data ? props.data.name || "" : ""), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          className: classes.mt16
        }, props.translation ? props.translation.texts ? props.translation.texts.date_repeats || "Acitivity's dates" : "Acitivity's dates" : "Acitivity's dates"), /*#__PURE__*/React.createElement("div", {
          className: classes.containerRepeatsEditor
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.titleRepeatContainer
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.translation ? props.translation.texts ? props.translation.texts.date_start || "Date start" : "Date start" : "Date start"), /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.translation ? props.translation.texts ? props.translation.texts.date_end || "Date end" : "Date end" : "Date end"), /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.translation ? props.translation.texts ? props.translation.texts.venue || "Venue" : "Venue" : "Venue")), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        }), props.data ? props.data.repeats ? props.data.repeats.map(function (repeat) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.repeatContainer
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body2"
          }, repeat.start ? moment(repeat.start).format("DD/MM/YYYY HH:mm") : "Invalid date start"), /*#__PURE__*/React.createElement(Typography, {
            variant: "body2"
          }, "-"), /*#__PURE__*/React.createElement(Typography, {
            variant: "body2"
          }, repeat.end ? moment(repeat.end).format("DD/MM/YYYY HH:mm") : "Invalid date end"), /*#__PURE__*/React.createElement(Chip, {
            label: repeat.venueName,
            className: classes.chip
          }));
        }) : "" : ""))), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          md: 6
        }, /*#__PURE__*/React.createElement("div", {
          className: classes.editor40vh
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.translation ? props.translation.texts ? props.translation.texts.details_family || "Family`s Description" : "Family`s Description" : "Family`s Description"), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.texts ? props.translation.texts.details_family_text || "This information will be visible for parents" : "This information will be visible for parents" : "This information will be visible for parents"), /*#__PURE__*/React.createElement("div", {
          className: classes.editor
        }, htmlParser(props.data ? props.data.description || "<p>Sin contenido</p>" : "<p>Sin contenido</p>"))), /*#__PURE__*/React.createElement("div", {
          className: classes.editor40vh
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1"
        }, props.translation ? props.translation.texts ? props.translation.texts.details_staff || "Staff`s Description" : "Staff`s Description" : "Staff`s Description"), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, props.translation ? props.translation.texts ? props.translation.texts.details_staff_text || "This information will be visible for staff" : "This information will be visible for staff" : "This information will be visible for staff"), /*#__PURE__*/React.createElement("div", {
          className: classes.editor
        }, htmlParser(props.data ? props.data.staffDetails || "<p>Sin contenido</p>" : "<p>Sin contenido</p>"))))), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.actions
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "medium",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: props.onClose
        }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
          size: "medium",
          color: "primary",
          variant: "outlined",
          onClick: function onClick() {
            return setVariant("edit");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.edit || "Edit" : "Edit" : "Edit")));
        break;

      default:
        break;
    }

    return content;
  };

  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "xl" // title={
    //   props.translation
    //     ? props.translation.titles
    //       ? props.translation.titles[variant] || "View Activity"
    //       : "View Activity"
    //     : "View Activity"
    // }
    ,
    open: props.open,
    onClose: props.onClose
  }, setContent());
};

export { DialogCampusGroupSingleActivity };